import {
  Box,
  Flex,
  Icon,
  IconButton,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import MessageBoxChat from '../MessageBoxChat/MessageBoxChat';
import { MdAutoAwesome, MdEdit, MdPerson } from 'react-icons/md';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import ReactMarkdown from 'react-markdown';
import { IoBookmark, IoBookmarks } from 'react-icons/io5';
import { BsBookmark, BsBookmarkFill } from 'react-icons/bs';
import { useSocket } from '../../Context/SocketContext';
import { useParams } from 'react-router-dom';

const ConversationCard = ({ conversation, chatType, showThinking }) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const brandColor = useColorModeValue('#603CFF', 'white');
  const textColor = useColorModeValue('#1B2559', 'white');

  const { name } = useParams();

  const [isBookmarked, toggleBookmarked] = useState(conversation?.isBookmarked);

  const [answerStep, setAnswerStep] = useState(conversation.parts.length ?? 1);
  const [dots, setDots] = useState('');

  const socket = useSocket();

  const handleBookmark = () => {
    if (!socket) return;

    const urlParams = new URLSearchParams(window.location.search);
    const associationID = urlParams.get('id');
    const course = urlParams.get('course');

    const payload = {
      questionID: conversation?.questionID,
      associationID,
      courseName: name || course,
      chatType,
    };

    toggleBookmarked(prev => {
      socket.emit('bookmarkConversation', {
        ...payload,
        isBookmarked: !prev,
      });
      return !prev;
    });

    console.log('Bookmark clicked');
  };

  const handleAnswerStep = operation => {
    if (operation === 'prev') {
      if (answerStep === 1) return;
      setAnswerStep(prevStep => prevStep - 1);
    } else {
      if (answerStep === conversation.parts.length) return;
      setAnswerStep(prevStep => prevStep + 1);
    }
  };

  useEffect(() => {
    if (!showThinking) {
      setDots('');
      return;
    }
    const interval = setInterval(() => {
      setDots(prevDots => (prevDots.length < 3 ? prevDots + '.' : ''));
    }, 500);

    return () => clearInterval(interval);
  }, [showThinking]);

  return (
    <Box>
      {conversation.role === 'user' ? (
        <Flex w="100%" align={'center'} mt="0.9rem" alignItems="baseline">
          <Flex
            borderRadius="full"
            justify="center"
            align="center"
            bg={'transparent'}
            border="1px solid"
            borderColor={borderColor}
            me={{ base: '5px', sm: '20px' }}
            h={{ base: '25px', sm: '35px' }}
            minH={{ base: '25px', sm: '35px' }}
            minW={{ base: '25px', sm: '35px' }}
          >
            <Icon
              as={MdPerson}
              width={{ base: '15px', sm: '20px' }}
              height={{ base: '15px', sm: '20px' }}
              color={brandColor}
            />
          </Flex>
          <Flex
            p="16px"
            border="1px solid"
            borderColor={borderColor}
            borderRadius="14px"
            w="100%"
            direction="column"
            maxW="85%"
          >
            {/* <Text
              color={textColor}
              fontWeight="600"
              fontSize={{ base: 'sm', md: 'md' }}
              lineHeight={{ base: '24px', md: '26px' }}
            > */}

            {/* {conversation.parts[answerStep - 1].text} */}
            {/* </Text> */}
            <Box
              px="22px !important"
              pl="22px !important"
              color={textColor}
              // minH="450px"
              fontSize={{ base: 'sm', md: 'md' }}
              lineHeight={{ base: '24px', md: '26px' }}
              fontWeight="500"
              boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
              width="100%"
              // p="20px"
              flexDirection="column"
              position="relative"
              borderRadius="14px"
              minWidth="0px"
              wordwrap="break-word"
              backgroundClip="border-box"
            >
              {/* <Flex alignItems="center">
  
   
              </Flex> */}

              <ReactMarkdown>
                {conversation.parts[answerStep - 1].text}
              </ReactMarkdown>

              {/* <IconButton
                position="absolute"
                top="0"
                right="0"
                aria-label={
                  conversation?.isBookmarked ? 'Bookmarked' : 'Bookmark'
                }
                icon={
                  conversation?.isBookmarked ? (
                    <Icon
                      position="absolute"
                      top="0"
                      right="0"
                      focusable={true}
                      as={IoBookmarks}
                      cursor="pointer"
                    />
                  ) : (
                    <Icon
                      position="absolute"
                      top="0"
                      right="0"
                      focusable={true}
                      as={IoBookmarks}
                      cursor="pointer"
                    />
                  )
                }
              /> */}

              <Icon
                position="absolute"
                top="0"
                right="0"
                focusable={true}
                as={isBookmarked ? BsBookmarkFill : BsBookmark}
                cursor="pointer"
                transition="all 0.2s"
                _hover={{
                  transform: 'scale(1.2)',
                  color: 'black',
                }}
                onClick={handleBookmark}
              />
            </Box>
            {/* <ReactMarkdown>
              {conversation.parts[answerStep - 1].text}
            </ReactMarkdown> */}
            {/* <MessageBoxChat output={conversation.parts[answerStep - 1].text} /> */}
            {/* <Icon
              cursor="pointer"
              as={MdEdit}
              ms="auto"
              width="20px"
              height="20px"
              color={'gray'}
            /> */}
          </Flex>
        </Flex>
      ) : (
        <Flex w="100%">
          <Flex
            borderRadius="full"
            justify="center"
            align="center"
            bg={'linear-gradient(15.46deg, #4A25E1 26.3%, #7B5AFF 86.4%)'}
            me={{ base: '5px', sm: '20px' }}
            h={{ base: '25px', sm: '35px' }}
            minH={{ base: '25px', sm: '35px' }}
            minW={{ base: '25px', sm: '35px' }}
          >
            <Icon
              as={MdAutoAwesome}
              width={{ base: '15px', sm: '20px' }}
              height={{ base: '15px', sm: '20px' }}
              color="white"
            />
          </Flex>
          <Flex direction="column" width="100%" maxW="85%">
            <MessageBoxChat
              output={conversation.parts[answerStep - 1].text + dots}
            />
            {/* <Box> */}
            {/* <Flex
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mb={2}
              width="fit-content"
              color="#101828"
            >
              <Icon
                as={FaChevronLeft}
                color="#101828"
                // p="0.5rem"
                w="0.6rem"
                height="0.6rem"
                cursor="pointer"
                m="0px 3px"
                onClick={() => handleAnswerStep('prev')}
                opacity={answerStep === 1 ? 0.2 : 1}
              />
              <Text fontSize="0.8rem">
                {answerStep}&nbsp;/&nbsp;{conversation.parts.length}
              </Text>
              <Icon
                as={FaChevronRight}
                color="#101828"
                // p="0.5rem"
                w="0.6rem"
                height="0.6rem"
                cursor="pointer"
                m="0px 3px"
                onClick={() => handleAnswerStep('next')}
                opacity={answerStep === conversation.parts.length ? 0.2 : 1}
              />
            </Flex> */}
            {/* </Box> */}
          </Flex>
        </Flex>
      )}
    </Box>
  );
};

export default ConversationCard;
